<mat-card>
  <div class="serch-details-container">
    <div class="search-details">
      <form class="search-form">
        <mat-form-field class="search-input" appearance="outline" style="width: 33% !important" id="form1">
          <input id="IdFam" name="nmFam" type="text" placeholder="{{'Family' | translate | async}}"
            (input)="familyChanged($event)" matInput [matAutocomplete]="autoF" [(ngModel)]="familyTitle"
            #autoCompleteInput="matAutocompleteTrigger" [ngModelOptions]="{standalone: true}">
          <mat-autocomplete [(ngModel)]="familyTitle" #model_auto1="ngModel" #autoF="matAutocomplete"
            (optionSelected)="onSelectFamily($event.option)">
            <mat-option [value]="type.Title" *ngFor="let type of _dropDownFamilyFiltered">
              {{ type.Title+' | '+type.Symbol }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="search-input" appearance="outline" style="width: 33% !important">
          <mat-icon matPrefix style=" color: #d7cfcf;
            font-size: 20px; ">search</mat-icon>
          <input id="IdMake" name="nmMake" type="text" placeholder="{{'Make' | translate | async}}"
            (input)="MakeChanged($event)" matInput [matAutocomplete]="autoMake" [(ngModel)]="makeTitle"
            #autoCompleteInput1="matAutocompleteTrigger" [ngModelOptions]="{standalone: true}">
          <mat-autocomplete [(ngModel)]="makeTitle" #model_auto2="ngModel" #autoMake="matAutocomplete"
            (optionSelected)="onSelectMake($event.option)">
            <mat-option [value]="make.Makedesc" *ngFor="let make of filteredMakeViewModel ">
              {{make.Makedesc }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="search-select-margin" #formField appearance="outline" style="width: 33% !important"
          id="form3">
          <mat-icon matPrefix style=" color: #d7cfcf;
  font-size: 20px; ">search</mat-icon>
          <input id="IdMod" name="nmMod" type="text" placeholder="{{'Model' | translate | async}}"
            (input)="changeModelAutoComplete($event)" matInput [matAutocomplete]="auto3" [(ngModel)]="modelTitle"
            #autoCompleteInput2="matAutocompleteTrigger" [ngModelOptions]="{standalone: true}">
          <mat-autocomplete [(ngModel)]="modelTitle" #model_auto3="ngModel" #auto3="matAutocomplete"
            (optionSelected)="onModelSelected($event.option)">
            <!-- <mat-option [value]="0">None</mat-option> -->
            <mat-option [value]="model.Title" *ngFor="let model of filteredModels">
              {{model.Title}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-spinner class="loading-spinner" *ngIf="modalLoding" [diameter]="50"></mat-spinner>
      </form>
    </div>
  </div>
  <div class="row" style="text-align: right;">
    <button mat-raised-button (click)="resetFields()"> {{'Reset' | translate | async}} </button>

    <button mat-raised-button color="warn" (click)="loadModelListGrid()" style="margin-left: 20px;margin-right: 20px;">
      {{'Search' | translate | async}}
    </button>
  </div>

</mat-card>
<div>
  <mat-card class="col-lg-12" style="padding: 20px; margin-top: 20px;" *ngIf="showTableView">
    <div class="panel_sub_header">
      <span class="panel__header__title">{{'Search Result' | translate | async}}</span>
    </div>
    <div>
      <label>{{'Select the model you would like to view/edit' | translate | async}}</label>
    </div>

    <!-- //<mat-spinner *ngIf="tableDataLoading"></mat-spinner> -->
    <div class="search-result-table-container mat-elevation-z8">

      <mat-table #table [dataSource]="dataSource">
        <ng-container matColumnDef="modeldesc">
          <mat-header-cell *matHeaderCellDef> {{'Model' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.modeldesc}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="typedesc">
          <mat-header-cell *matHeaderCellDef> {{'Family' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.typedesc}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="makedesc">
          <mat-header-cell *matHeaderCellDef> {{'Make' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.makedesc}} </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns; " [ngClass]="{ 'selected': row === selectRow }"
          (click)="selectRow(row)"></mat-row>
      </mat-table>
      <div *ngIf="dataSource.data.length === 0" class="no-data">{{'No data available' | translate | async}}</div>
    </div>
  </mat-card>
  <mat-spinner class="loading-spinner" *ngIf="tableDataLoading"></mat-spinner>
</div>

<div class="row">
  <div class="col-lg-12">
    <mat-accordion class="example-headers-align" multi style="padding: 10px; margin-top: 20px;">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="expansion-header"> {{'Model Details' | translate | async}} </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="model-details-input mat-input-width">
              <input matInput required name="modelid_" [(ngModel)]="modelid" #modelid_="ngModel" placeholder="{{'Model ID' | translate | async}}">
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field class="model-details-input mat-input-width">
              <input required matInput placeholder="{{'Model Description' | translate | async}}" name="modeldesc" [(ngModel)]="modeldesc">
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field class="search-input" appearance="outline" style="width: 80%">
              <input type="text" placeholder="{{'Industry' | translate | async}}" (input)="industryChanged($event)"
                matInput [matAutocomplete]="auto4" [(ngModel)]="industry_name_new"
                #autoCompleteInput3="matAutocompleteTrigger">
              <mat-autocomplete [(ngModel)]="industry_name_new" #model_auto4="ngModel" #auto4="matAutocomplete"
                (optionSelected)="onSelectIndustry($event.option)">
                <mat-option [value]="type.Title" *ngFor="let type of eqIndustryListFilter">
                  {{ type.Title }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="search-input" appearance="outline" style="width:80%">
              <input required type="text" placeholder="{{'Family' | translate | async}}"
                (input)="familyChangedMain($event)" matInput [matAutocomplete]="auto5" [(ngModel)]="typedesc"
                #autoCompleteInput4="matAutocompleteTrigger">
              <mat-autocomplete [(ngModel)]="typedesc" #model_auto5="ngModel" #auto5="matAutocomplete"
                (optionSelected)="onSelectFamilyMain($event.option)">
                <mat-option [value]="type.Title" *ngFor="let type of _dropDownFamilyFilteredMain">
                  {{ type.Title+' | '+type.Symbol }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="col-md-4">

            <mat-form-field class="search-input" appearance="outline" style="width:80%">
              <input required type="text" placeholder="{{'Make' | translate | async}}" (input)="MakeChangedMain($event)"
                matInput [matAutocomplete]="auto6" [(ngModel)]="makedesc" #autoCompleteInput5="matAutocompleteTrigger">
              <mat-autocomplete [(ngModel)]="makedesc" #model_auto6="ngModel" #auto6="matAutocomplete"
                (optionSelected)="onSelectMakeMain($event.option)">
                <mat-option [value]="customer.Makedesc" *ngFor="let customer of filteredMakeViewModelMain ">
                  {{customer.Makedesc}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field class="search-input" appearance="outline" style="width: 80%">
              <input type="text" placeholder="{{'Default Inspection Cycle' | translate | async}}"
                (input)="defaultInspectionCycleChanged($event)" matInput [matAutocomplete]="auto7"
                [(ngModel)]="service_cycle_type" #autoCompleteInput6="matAutocompleteTrigger">
              <mat-autocomplete [(ngModel)]="service_cycle_type" #model_auto7="ngModel" #auto7="matAutocomplete"
                (optionSelected)="onSelectdefaultInspectionCycle($event.option)">
                <mat-option [value]="type.Title" *ngFor="let type of serviceCycleListFilter">
                  {{ type.Title }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4" style="margin-top: 20px;" appearance="outline">
            <mat-form-field class="model-details-input mat-input-width">
              <mat-select placeholder="{{'BaseModel' | translate | async}}" name="BaseModelId"
                [(ngModel)]="BaseModelId">
                <mat-option *ngFor="let type of baseModelList" [value]="type.Id">
                  {{ type.Title }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <div class="col-md-4">
            <mat-form-field class="model-details-input mat-input-width">
              <textarea matInput placeholder="Model Note" name="ModelNote" [(ngModel)]="ModelNote" autocomplete="off"
                autocorrect="off" autocapitalize="off" spellcheck="false"></textarea>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2" style="display: flex;">
            <div class="checkbox-wrapper">
              <label>
                {{'Component Detail' | translate | async}}
                <mat-checkbox (change)="componentDetailCheck($event)" [(ngModel)]="componentChecked">
                </mat-checkbox>
              </label>
            </div>
            <div class="checkbox-wrapper">
              <label>
                {{'Upload to Mobile' | translate | async}}
                <mat-checkbox name="uploadToMobile_" [(ngModel)]="uploadToMobile">
                </mat-checkbox>
              </label>
            </div>
          </div>
          <div class="col-md-3" style="text-align:center;">
            <label style="font-weight:500;">
              {{'Model Image' | translate | async}}
            </label>
            <div class="image-container">
              <img style="width:150px;height:150px" *ngIf="ModelImage" [src]="sanitize(ModelImage)">
              <img style="width:150px;height:150px"
                src="../../../../../../Content/Images/DefaultImages/DefaultImage.png" *ngIf="!ModelImage">
              <input style="display:none" type="file" (change)="onSelectPhoto($event,1)" #fileInput>
            </div>
            <button class="choose-image-btn" style="margin-top:5px" mat-raised-button (click)="fileInput.click()">
              {{'Choose file' | translate | async}}
            </button>
          </div>
          <div class="col-md-3" style="text-align:center;">
            <label style="font-weight:500;">
              {{'Model Image Left' | translate | async}}
            </label>
            <div class="image-container">
              <img style="height:150px" *ngIf="ModelImageLeft && !IsURLL" [src]="ModelImageLeft">
              <img style="height:150px" *ngIf="ModelImageLeft && IsURLL" [src]="sanitize(ModelImageLeft)">
              <img style="width:150px;height:150px"
                src="../../../../../../Content/Images/DefaultImages/DefaultImage.png" *ngIf="!ModelImageLeft">
              <input style="display:none" type="file" (change)="onSelectPhoto($event,2)" #fileInputLeft>
            </div>
            <button class="choose-image-btn" style="margin-top:5px" mat-raised-button (click)="fileInputLeft.click()">
              {{'Choose file' | translate | async}}
            </button>
          </div>
          <div class="col-md-3" style="text-align:center;">
            <label style="font-weight:500;">
              {{'Model Image Right' | translate | async}}
            </label>
            <div class="image-container">
              <img style="height:150px" *ngIf="ModelImageRight && !IsURLR" [src]="ModelImageRight"[style.transform]="IsRightImageRotate
                    ? 'scaleX(-1)'
                    : null" >
              <img style="height:150px" *ngIf="ModelImageRight && IsURLR" [src]="sanitize(ModelImageRight)">
              <img style="width:150px;height:150px"
                src="../../../../../../Content/Images/DefaultImages/DefaultImage.png" *ngIf="!ModelImageRight">
              <input style="display:none" type="file" (change)="onSelectPhoto($event,3)" #fileInputRight>
            </div>
            <button class="choose-image-btn" style="margin-top:5px" mat-raised-button (click)="fileInputRight.click()">
              {{'Choose file' | translate | async}}
            </button>
          </div>
          
        </div>
        <div class="row">
          <div class="col-md-9"></div>
          <div class="col-md-3" style="text-align: right;">
            <div class="btn-group"
              style="margin-top:20px;">
              <button mat-raised-button style="margin-right:5px;" color="warn" *ngIf="!isNew" (click)="saveUpdateSetupModel()">
                {{'Update'  | translate | async}}
              </button>
              <button mat-raised-button style="margin-right:5px;" color="warn" *ngIf="isNew" (click)="saveUpdateSetupModel()">
                {{'Add' | translate | async}}
              </button>
              <button mat-raised-button style="margin-right:5px;" color="warn" *ngIf="!isNew" (click)="deleteSetupModel()">
                {{'Delete' | translate | async}}
              </button>
              <button mat-raised-button  style="margin-right:5px;" color="warn" (click)="resetFields()">
                {{'Cancel' | translate | async}}
              </button>
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-accordion class="example-headers-align" multi style="padding: 10px; margin-top: 20px;"
        *ngIf="chainSectionShow">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="expansion-header"> {{'Chains Available' | translate | async}} </mat-panel-title>

          </mat-expansion-panel-header>
          <mat-card style="padding: 10px; margin-top: 20px;">

            <div class="row">
              <div class="col-lg-6"> <mat-card-title></mat-card-title></div>
              <div class="col-lg-6">
                <button style="float:right ;margin-bottom: 20px;" mat-raised-button color="warn"
                  (click)="ResetChainFileds()">{{'Add Chain' | translate | async}}</button>
              </div>
            </div>
            <mat-card-content>


              <div *ngIf="showTableChainView" class="table-container ">
                <!--Table-->
                <mat-table class=" mat-elevation-z8" #table [dataSource]="dataSourceChain" matSort style="width: 100%;">



                  <ng-container matColumnDef="chaindesc">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Chain Description' | translate | async}}
                    </mat-header-cell>
                    <mat-cell mat-cell *matCellDef="let element"> {{element.Description}} </mat-cell>
                  </ng-container>

                  <!-- Name Column -->
                  <ng-container matColumnDef="startsrno">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Serial Number Start' | translate | async}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ModelSerialNumberStart}} </mat-cell>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="endsrno">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Serial Number End' | translate | async}}
                    </mat-header-cell>
                    <mat-cell mat-cell *matCellDef="let element"> {{element.ModelSerialNumberEnd}} </mat-cell>
                  </ng-container>

                  <!-- Symbol Column -->
                  <ng-container matColumnDef="pitch">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Pitch' | translate | async}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.Pitch}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="noOflinks">
                    <mat-header-cell mat-header-cell *matHeaderCellDef> {{'# of Links' | translate | async}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.NumberOfLinks}} </mat-cell>
                  </ng-container>


                  <mat-header-row *matHeaderRowDef="displayedColumnsChain"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumnsChain; "
                    [ngClass]="{ 'selected': row === selectRowChain1 }" (click)="selectRowChain(row)"></mat-row>
                </mat-table>
              </div>
              <div *ngIf="dataSourceChain.data.length == 0" class="no-data">{{'No data available!' | translate | async}}
              </div>
              <mat-spinner class="loading-spinner" *ngIf="chainDataLoading"></mat-spinner>

            </mat-card-content>

          </mat-card>

          <mat-card style="padding: 20px; margin-top: 20px;" *ngIf="chainCreateSection">
            <div class="row">
              <div class="col-lg-12">
                <mat-card-title>Chain</mat-card-title>
              </div>

              <mat-card-content>
                <form class="example-form">
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input matInput required name="{desription}" [(ngModel)]="chainDescription" #description="ngModel"
                        [ngModelOptions]="{standalone: true}" placeholder="{{'Description' | translate | async}}">
                    </mat-form-field>
                  </div>

                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input matInput name="serialnumberstart" [(ngModel)]="serialNumberstart"
                        #serialnumberstart="ngModel" placeholder="{{'Serial Number Start' | translate | async}}">
                    </mat-form-field>
                  </div>

                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input matInput name="serialnumberend" [(ngModel)]="serialNumberEnd" #serialnumberend="ngModel"
                        [ngModelOptions]="{standalone: true}" placeholder="{{'Serial Number End' | translate | async}}">
                    </mat-form-field>
                  </div>
                </form>
              </mat-card-content>

            </div>
            <mat-tab-group>
              <mat-tab label="Chain" style="overflow-x: hidden;">
                <div class="row" style="padding: 10px; overflow-x: hidden;">
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input type="number" matInput name="pitch_" [(ngModel)]="pitch" #pitch_="ngModel"
                        placeholder="{{'Pitch' | translate | async}}">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input type="number" matInput required name="noOfLinks_" [(ngModel)]="noOfLinks"
                        #description_="ngModel" placeholder="{{'No Of Links' | translate | async}}">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input type="number" matInput name="linkHeight_" [(ngModel)]="linkHeight" #linkHeight_="ngModel"
                        placeholder="{{'Link Height' | translate | async}}">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input type="number" matInput name="numberOfIdlers_" [(ngModel)]="numberOfIdlers"
                        #numberOfIdlers_="ngModel" placeholder="{{'Number of Idlers' | translate | async}}">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input type="number" matInput name="boltHoleDiameter_" [(ngModel)]="boltHoleDiameter"
                        #boltHoleDiameter_="ngModel" placeholder="{{'Bolt Hole Diameter' | translate | async}}">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input type="number" matInput name="bushingOD_" [(ngModel)]="bushingOD" #bushingOD_="ngModel"
                        placeholder="{{'Bushing Outside Diameter' | translate | async}}">
                    </mat-form-field>
                  </div>


                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input type="number" matInput name="numberOfCarrierRollers_" [(ngModel)]="numberOfCarrierRollers"
                        #numberOfCarrierRollers_="ngModel"
                        placeholder="{{'Number Of CarrierRollers' | translate | async}}">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input type="number" matInput name="chainInsideSpread_" [(ngModel)]="chainInsideSpread"
                        #chainInsideSpread_="ngModel" placeholder="{{'Chain Spread Inside' | translate | async}}">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input type="number" matInput name="chainOutsideSpread_" [(ngModel)]="chainOutsideSpread"
                        #chainOutsideSpread_="ngModel" placeholder="{{'Chain Spread Outside' | translate | async}}">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input type="number" matInput name="numberOfTrackRollers_" [(ngModel)]="numberOfTrackRollers"
                        #numberOfTrackRollers_="ngModel" placeholder="{{'Number Of TrackRollers' | translate | async}}">
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <button *ngIf="!isUpdating" style="float: right;" mat-raised-button color="warn"
                      (click)="saveUpdateSetupChain()"> {{"Save" | translate | async}} </button>
                    <button *ngIf="isUpdating" style="float: right;" mat-raised-button color="warn"
                      (click)="saveUpdateSetupChain()"> {{"Update" | translate | async}} </button>

                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Hardware">
                <div class="row" style="padding: 10px; ">
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input matInput required name="chainHardwareDescription_" [(ngModel)]="chainHardwareDescription"
                        #chainHardwareDescription_="ngModel" placeholder="{{'Description' | translate | async}}">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input matInput name="bercoPartNumber_" [(ngModel)]="bercoPartNumber" #bercoPartNumber_="ngModel"
                        placeholder="{{'Berco Part Number' | translate | async}}">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input matInput name="casePartnumber_" [(ngModel)]="casePartnumber" #casePartnumber_="ngModel"
                        placeholder="{{'Case Part Number' | translate | async}}">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input matInput type="number" required name="quantity_" [(ngModel)]="quantity"
                        #quantity_="ngModel" placeholder="{{'Quantity' | translate | async}}">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <mat-select placeholder="{{'Part Line' | translate | async}}" name="partLine"
                        [(ngModel)]="partLineId">
                        <mat-option *ngFor="let item of partLineList" [value]="item.Id">
                          {{ item.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field class="mat-input-width">
                      <input matInput type="number" name="cost_" [(ngModel)]="cost" #cost_="ngModel"
                        placeholder="{{'Cost' | translate | async}}">
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <button *ngIf="!isUpdating" style="float: right;" mat-raised-button color="warn"
                      (click)="update_Hardware()"> {{"Save" | translate | async}} </button>
                    <button *ngIf="isUpdating" style="float: right;" mat-raised-button color="warn"
                      (click)="update_Hardware()"> {{"Update" | translate | async}} </button>

                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </mat-card>
        </mat-expansion-panel>
      </mat-accordion>



      <mat-card *ngIf="newRow" class="mt-5">
        <mat-tab-group>
          <mat-tab label="{{'Components' | translate | async}}">

            <div class="type-title ">
              <div class="panel_sub_header">
                <span class="panel__header__title">{{modelid}} - {{"Component Details" | translate | async}}</span>
              </div>
            </div>
            <div class="search-result-table-container mat-elevation-z8">
              <mat-table #table [dataSource]="dataSource_">

                <ng-container matColumnDef="chain">
                  <mat-header-cell *matHeaderCellDef> {{"Chain" | translate | async}} </mat-header-cell>



                  <mat-cell *matCellDef="let element">

                    <section class="example-section">
                      <mat-checkbox class="example-margin" [checked]="element.isActive"
                        (change)="ChainAttachDeattach($event,element.CompartModelMappingAuto,element.ChainModelComponentMapId)"></mat-checkbox>
                    </section>

                    <!-- <div *ngIf="element.isActive!=null;else checkDisable">
                      <section class="example-section">
                        <mat-checkbox  class="example-margin" [checked]="element.isActive" (change)="ChainAttachDeattach($event,element.CompartModelMappingAuto,element.ChainModelComponentMapId)"></mat-checkbox>
                      </section>
                    </div>
                   <ng-template #checkDisable>
                    <section class="example-section">
                      <mat-checkbox  class="example-margin" [disabled]="true"></mat-checkbox>
                    </section>
                   </ng-template> -->

                  </mat-cell>
                </ng-container>


                <ng-container matColumnDef="comparttype">
                  <mat-header-cell *matHeaderCellDef> {{"Component Type" | translate | async}} </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.comparttype}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="compartid">
                  <mat-header-cell *matHeaderCellDef> {{"Component ID" | translate | async}} </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.compartid}} </mat-cell>
                </ng-container>


                <ng-container matColumnDef="compart">
                  <mat-header-cell *matHeaderCellDef> {{"Component" | translate | async}} </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.compart}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="makedesc">
                  <mat-header-cell *matHeaderCellDef> {{"Make" | translate | async}} </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.makedesc}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="compart_note">
                  <mat-header-cell *matHeaderCellDef> {{"Note" | translate | async}} </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.compart_note}} </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns_"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns_; "
                  [ngClass]="{ 'selected': row === selectedRow }"></mat-row>

              </mat-table>
            </div>
            <div *ngIf="dataSource_.data.length == 0" class="no-data">{{"No data available!" | translate | async}}</div>

            <mat-spinner class="loading-spinner" *ngIf="tableDataLoading"></mat-spinner>

          </mat-tab>

          <mat-tab label="{{'Component Type Availability' | translate | async}}">
            <div class="type-container">
              <div class="type-title" style="margin-bottom: 2%">
                <div class="panel_sub_header">
                  <span class="panel__header__title">{{modelid}} - {{"Component Type Availability" | translate |
                    async}}</span>
                </div>
              </div>
              <div class="type-body">
                <div class="type-body-1">
                  <div class="type-list-item-container" *ngFor="let type of componentType_">
                    <div *ngIf="type.Order == 1">
                      <mat-icon class="right-icon-done">done</mat-icon>
                      <label>{{type.Typeid}}</label>
                    </div>

                    <div *ngIf="type.Order == 0">
                      <mat-icon class="right-icon-close">close</mat-icon><label>{{type.Typeid}}</label>

                    </div>
                  </div>
                </div>

              </div>

            </div>
          </mat-tab>

          <mat-tab label="{{'Observations' | translate | async}}">
            <div class="type-title ">
              <div class="panel_sub_header">
                <span class="panel__header__title">{{modelid}} - {{"Observation Details" | translate | async}}</span>
              </div>
              <div>
                <span class="panel__header__title" style="padding-right: 20px;">{{"Mobile Screen Display of Observations:" | translate | async}}
                </span>
                <mat-radio-group style="justify-content: space-between;" [(ngModel)]="UCConditionDisplayOption"
                  (change)="toggleUCConditions($event)">
                  <mat-radio-button class="conditons-radio-buttons" [value]="1">{{"Equipment Conditions" | translate |
                    async}}</mat-radio-button>&nbsp;&nbsp;&nbsp;
                  <mat-radio-button class="conditons-radio-buttons" [value]="2">{{"Components Screen" | translate |
                    async}}</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <button  mat-raised-button color="warn" *ngIf="observationLists==null || observationLists.length==0"
              (click)="EnableObservationsPoints()">
              <span class="button__text">{{"Enabled" | translate | async}}</span>
            </button>
            <table class="table table--full-width table--striped">
              <thead>
                <tr>
                  <th>{{'Title' | translate | async}}</th>
                  <th>{{'Type' | translate | async}}</th>
                  <th>{{'Image' | translate | async}}</th>
                  <th>{{'Details' | translate | async}}</th>
                  <th>{{'Visibility' | translate | async}}</th>
                </tr>
              </thead>
              <tbody *ngIf="observationLists?.length > 0" [@slideOut]>
                <tr *ngFor="let ob of observationLists">

                  <td> {{ob.Title}} </td>
                  <td> {{ob.Type}} </td>

                  <td class="inspection-component-photo">

                    <img style="width:100px; height:100px" *ngIf="ob.ToolImage!='' && ob.ToolImage!=null"
                      class="inspection-observation-photo" [src]="getImage(ob.ToolImage)" />
                    <img *ngIf="ob.ToolImage=='' || ob.ToolImage==null" class="inspection-observation-photo"
                      src="../../../../../../Content/Images/NO-IMAGE.png" />

                  </td>
                  <td *ngIf="ob.Type=='Limits'">
                    <button mat-raised-button color="warn" style="z-index: 99;" (click)="EditLimits(ob)">
                      <span class="button__text">{{'Update Limits' | translate | async}}</span>
                    </button>
                  </td>
                  <td *ngIf="ob.Type!='Limits'">

                  </td>
                  <td *ngIf="ob.Active==true">
                    <i class="material-icons" style="cursor: pointer;" (click)="UpdateVisibilityForObservation(ob.Id)">
                      visibility</i>
                  </td>
                  <td *ngIf="ob.Active==false">
                    <i class="material-icons" style="cursor: pointer;"
                      (click)="UpdateVisibilityForObservation(ob.Id)">visibility_off</i>
                  </td>

                </tr>
            </table>
            <mat-spinner class="loading-spinner" *ngIf="tableDataLoading"></mat-spinner>
          </mat-tab>
        </mat-tab-group>
      </mat-card>
    </mat-accordion>
    <!--end form model setup -->
  </div>
</div>